import { getSettings } from "../services/popularService.service";

export const isSettingsUrl = (url = "") => {
    return ["v1/settings"].includes(url);
};

export const isSettingsChanged = (timeStamp) =>
    parseInt(localStorage.getItem("settingsHash")) !== parseInt(timeStamp);

export const setSettingsStorage = (settings) => {
    localStorage.setItem("settings", JSON.stringify(settings));
};

export const setSettingsHashStorage = (timestamp) => {
    localStorage.setItem("settingsHash", timestamp);
};

export const getSettingsStorage = (key) => {
    let settings = localStorage.getItem("settings");
    settings = settings ? JSON.parse(settings) : null;
    if (key && settings) {
        return settings[key] || null;
    }
    return settings;
};

export const settingsHandler = async () => {
    try {
        const res = await getSettings();
        if (res?.data?.data && res?.headers?.["x-settings-timestamp"]) {
            setSettingsStorage(res?.data?.data);
            setSettingsHashStorage(res?.headers?.["x-settings-timestamp"]);
        }
    } catch (e) {
        return console.log(e);
    }
};
